import clsx, { type ClassValue } from "clsx"
import { twMerge, type ClassNameValue } from "tailwind-merge"

export function cn(...classNames: (ClassNameValue | ClassValue)[]) {
  return twMerge(clsx(classNames))
}
